import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import PropTypes from 'prop-types';
import React from 'react';

export const style = {
  group: {
    margin: '1em 0'
  },
  button: {
    marginTop: '1em'
  }
};

const RadioButtons = ({ onChange, value, name, choices }) => (
  <RadioButtonGroup
    name={name}
    style={style.group}
    onChange={(event) => onChange(event.target.value)}
    valueSelected={value}
  >
    {choices.map(({ value, label }) => (
      <RadioButton key={value} value={value} label={label} style={style.button} />
    ))}
  </RadioButtonGroup>
);

RadioButtons.propTypes = {
  choices: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  name: PropTypes.string.isRequired
};

export default RadioButtons;



// WEBPACK FOOTER //
// ./src/components/RadioButtons.js